/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'twitter': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#50abf1" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M4.239 23.721a13.702 13.702 0 007.364 2.132c7.608 0 13.775-6.168 13.775-13.775 0-.19-.004-.378-.011-.566.275-.217 1.977-1.581 2.394-2.458 0 0-1.382.574-2.735.71l-.009.001.007-.005c.125-.083 1.867-1.269 2.103-2.683 0 0-.978.522-2.346.978-.227.075-.464.149-.708.218a4.832 4.832 0 00-8.237 4.397c-.373-.015-6.055-.334-9.921-5.015 0 0-2.31 3.154 1.377 6.397 0 0-1.121-.045-2.088-.622 0 0-.355 3.821 3.82 4.798 0 0-.822.311-2.132.089 0 0 .733 3.087 4.443 3.376 0 0-2.933 2.65-7.098 2.028h.001z"/>'
  }
})
